export enum SaleScope {

    VenditaNormale = 'Vendita',
    VenditaDaParte = "VenditaDaParte",
    DaParteNuovoProdotto = 'DaParteNuovoProdotto',
    DaParteAcconto = 'DaParteAcconto',
    DaParteConcludi = 'DaParteVendita'

}
